module.exports = __webpack_public_path__ + "static/media/aa-travel-info.ad04f7b0.png";